import React from 'react';

export const Card = ({ title, children }) => (
  <div style={{ background:'#fff', borderRadius:12, padding:'clamp(12px, 3.2vw, 16px)', boxShadow:'0 2px 10px rgba(0,0,0,0.06)', width:'100%', maxWidth:'100%', boxSizing:'border-box', overflowX:'hidden' }}>
    <div style={{ fontWeight:600, fontSize:16, marginBottom:8 }}>{title}</div>
    {children}
  </div>
);

export const Row = ({ label, value }) => (
  <div style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #f2f2f2' }}>
    <div style={{ color:'#666' }}>{label}</div>
    <div style={{ fontWeight:500 }}>{value ?? '-'}</div>
  </div>
);

// Lightweight shimmering skeleton placeholder
export const Skeleton = ({ width = '100%', height = 12, radius = 6, style = {} }) => (
  <div style={{ margin:'4px 0' }}>
    <style>{`
      @keyframes kk-shimmer { 0% { background-position: -200px 0; } 100% { background-position: calc(200px + 100%) 0; } }
    `}</style>
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background: 'linear-gradient(90deg, #eef2f7 25%, #e5ebf3 50%, #eef2f7 75%)',
        backgroundSize: '200px 100%',
        animation: 'kk-shimmer 1.2s ease-in-out infinite',
        ...style,
      }}
    />
  </div>
);
